import { useTranslation } from 'react-i18next';
import { useRouteMatch } from 'react-router';

import * as graphql from '@treams/treams-network';
import { PageType } from '@treams/treams-network';
import { Jumbo } from '@treams/treams-ui';

import OutgoingFeedbackList from './OutgoingFeedbackList';
import UserFeedbackButtons from './UserFeedbackButtons';
import UserFeedbackTabs from './UserFeedbackTabs';

export default function ViewerOutgoingFeedback() {
	const { t } = useTranslation();

	const { params } = useRouteMatch<{ id: string }>();
	const userID = params.id;

	const userQuery = graphql.useUserQuery({ variables: { id: userID } });

	const query = graphql.useOutgoingFeedbackResponsesQuery({
		variables: { userID, last: 10 },
	});

	return (
		<>
			<Jumbo.Editable
				hasMediaUpload
				page={PageType.FeedbackGiven}
				title={t('user.feedback.outgoing.title', { name: userQuery.data?.user.firstName })}
				button={<UserFeedbackButtons user={userQuery.data?.user as graphql.User} />}
				footer={<UserFeedbackTabs user={userQuery.data?.user as graphql.User} />}
			/>

			<OutgoingFeedbackList query={query} userID={userID} />
		</>
	);
}
